import { createFeatureSelector } from "@ngrx/store";
import { LOCAL_STORAGE_REDUCERS } from "src/app/configs/libraries/ngrx-redux/ngrx";
import { State } from "./device.reducer";

export const selectDevices = createFeatureSelector<State>(LOCAL_STORAGE_REDUCERS.DEVICES);

